import { render } from "./FlagSection.vue?vue&type=template&id=5ed4ee9f&scoped=true"
import script from "./FlagSection.vue?vue&type=script&lang=js"
export * from "./FlagSection.vue?vue&type=script&lang=js"

import "./FlagSection.vue?vue&type=style&index=0&id=5ed4ee9f&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed4ee9f"]])

export default __exports__